import { propertyManagingAgentCard } from '../../shared';
import type { OfferLocaleOverrides } from '../base';
import {
  buyersAttorneyContactCard,
  sellersAttorneyContactCard,
} from '../cards';

export const NYOverrides: OfferLocaleOverrides = {
  locale: 'NY',
  sections: {
    buySideContacts: {
      cards: {
        buyersAttorneyContactCard,
      },
    },
    sellerSideContacts: {
      cards: {
        sellersAttorneyContactCard,
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => propertyManagingAgentCard,
      },
    },
  },
};
